var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSixPointedStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione-monotone",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.262 32L60 16H40.522L32 2l-8.521 14H4l9.739 16L4 48h19.479L32 62l8.522-14H60l-9.738-16zm.459-11l-3.547 5.928L43.566 21h7.155zm-6.58 11l-6.578 11H26.439l-6.578-11l6.578-11h11.123l6.579 11zM32 11.701L34.572 16H29.43L32 11.701zM13.283 21h7.151l-3.607 5.926L13.283 21zm0 22l3.544-5.926L20.435 43h-7.152zM32 52.299L29.43 48h5.143L32 52.299zm15.174-15.227L50.721 43h-7.154l3.607-5.928z",
    fill: "#a881fe"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 32,
    rx: 4.199,
    ry: 4.286,
    fill: "#a881fe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSixPointedStar);
export default __webpack_public_path__ + "static/media/six-pointed-star.1357e473226540089ead636f4bdbc155.svg";
export { ForwardRef as ReactComponent };